// extracted by mini-css-extract-plugin
export default {"header":"header_header__rv4sW","headerBox":"header_headerBox__yjEbJ","kgms":"header_kgms__qi0Ln","theWorldBank":"header_theWorldBank__rI7Ek","logo":"header_logo__0PgZ6"};